import { systemIds } from '@/shared/utils';
/**
 * 进度
 */
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['schedule'], // 为了获取基础路由
    };
};
//bussinessCode 和 各菜单 审批路由 的 映射
export const scheduleToPathNameMap = {
    //进度管理-进度编制计划
    schedule1010: ({ businessKey, variables: { planType } }) => {
        let prefix = 'total';
        switch (planType) {
            case 1:
                prefix = 'total';
                break;
            case 2:
                prefix = 'year';
                break;
            case 3:
                prefix = 'month';
                break;
        }
        return commonFunc(`/${prefix}/plan/detail/${businessKey}`);
    },
    //进度管理-进度编制调整计划
    schedule1020: ({ businessKey, variables: { planType } }) => {
        let prefix = 'total';
        switch (planType) {
            case 1:
                prefix = 'total';
                break;
            case 2:
                prefix = 'year';
                break;
            case 3:
                prefix = 'month';
                break;
        }
        return commonFunc(`/${prefix}/adjust/detail/${businessKey}`);
    },
    //进度管理-项目形象进度
    schedule1080: ({ businessKey }) => commonFunc(`/image/establish/detail/${businessKey}`),
    //进度管理-项目形象进度调整
    schedule1090: ({ businessKey }) => commonFunc(`/image/adjust/detail/${businessKey}`),
    //进度管理-年产值计划
    schedule2010: ({ businessKey }) => commonFunc(`/prodution/establish/detail/${businessKey}`),
    //进度管理-年产值计划调整
    schedule2020: ({ businessKey }) => commonFunc(`/prodution/adjust/detail/${businessKey}`),
    //进度管理-年计划编制-按中标清单
    schedule3010: ({ businessKey }) => commonFunc(`/year/winbid/detail/${businessKey}`),
    //进度管理-年计划调整-按中标清单
    schedule3020: ({ businessKey }) => commonFunc(`/year/winbidAdjust/detail/${businessKey}`),
};
